jQuery(document).ready(function($){

    $('a.see-more-trigger').click(function() {
        event.preventDefault();

        readmoreReset();
        $(this).parent('.testimonial-quote').addClass('show-more');
      });

    function readmoreReset() {
        $('.testimonial-quote').removeClass('show-more');
    }

});